export default "__VITE_PUBLIC_ASSET__cd895d97__"